/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Qwick Core API
 * AKA V3, AKA Gigpro, AKA sidegig-api
 * OpenAPI spec version: 0.0.0
 */

/**
 * * `ALL` - Open to the whole Marketplace (default / legacy behaviour)
 * * `GROUP` - Offered to the members of a single ProGroup
 * * `PROS` - Offered to an explicit list of pros
 * * `FAVORITES` - Offered to the location's favorite pros
 */
export type GigAudienceTypeEnum = typeof GigAudienceTypeEnum[keyof typeof GigAudienceTypeEnum];


export const GigAudienceTypeEnum = {
  ALL: 'ALL',
  GROUP: 'GROUP',
  PROS: 'PROS',
  FAVORITES: 'FAVORITES',
} as const;
